module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('span', {
    staticClass: "order-info-block"
  }, [_c('span', {
    staticClass: "order-label"
  }, [_vm._v("Ordered")]), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("moment")(_vm.order.ordered_at, 'MM/DD/YYYY hh:mm A [PT]z'))), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/orders/' + _vm.order.id,
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.order.site_code) + _vm._s(_vm.order.id) + "\n      ")])]), _vm._v(" "), (_vm.shipped) ? _c('span', {
    staticClass: "order-info-block"
  }, [_c('span', {
    staticClass: "order-label"
  }, [_vm._v("Shipped")]), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("moment")(_vm.order.shipped_at, 'MM/DD/YYYY hh:mm A [PT]z'))), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.order.shipping_status.shipping_link,
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.order.shipping_method_short_name || _vm.order.shipping_method) + "\n      ")])]) : _c('span', {
    staticClass: "order-info-block"
  }, [_c('span', {
    staticClass: "order-label"
  }, [_vm._v("Production")]), _c('br'), _vm._v(" "), (_vm.order.processed_at) ? [_vm._v("\n        " + _vm._s(_vm._f("moment")(_vm.order.processed_at, 'MM/DD/YYYY hh:mm A [PT]z')) + "\n      ")] : [_vm._v("\n        In Queue To Send\n      ")]], 2), _vm._v(" "), _c('span', {
    staticClass: "order-info-block"
  }, [_c('span', {
    staticClass: "order-label"
  }, [_vm._v("Ship To")]), _c('br'), _vm._v("\n      " + _vm._s(_vm.order.shipping_info.name)), _c('br'), _vm._v("\n      " + _vm._s(_vm.order.shipping_info.company) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "order-info-block"
  }, [_c('span', {
    staticClass: "order-label"
  }, [_vm._v("Bill To")]), _c('br'), _vm._v("\n      " + _vm._s(_vm.order.billing_info.name)), _c('br'), _vm._v("\n      " + _vm._s(_vm.order.billing_info.company) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "right right-align mt-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "to": '/reorder/' + _vm.order.id
    }
  }, [_vm._v("Reorder")])], 1)]), _vm._v(" "), _vm._l((_vm.order.items), function(item, index) {
    return (_vm.order.items.length > 0) ? [_c('v-layout', _vm._b({}, 'v-layout', _vm.layout, false), [_c('v-flex', {
      staticClass: "center-align",
      attrs: {
        "xs1": "",
        "mx-3": "",
        "mt-2": ""
      }
    }, [(item.file) ? _c('a', {
      attrs: {
        "href": item.file.files.preview,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "elevation-3 preview-image responsive-img",
      attrs: {
        "src": item.file.thumbs.small,
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs11": "",
        "pt-3": ""
      }
    }, [_c('item-description', {
      attrs: {
        "item": item,
        "orderInfo": true
      }
    })], 1)], 1)] : _vm._e()
  }), _vm._v(" "), (_vm.order.items.length === 0) ? [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-3": "",
      "mt-2": "",
      "mb-2": ""
    }
  }, [_vm._v("\n        No Items Found\n      ")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e466b2c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/card.vue
// module id = 780
// module chunks = 1